import { Icon } from '@iconify/react';
import { useGet, useSet } from 'ccstate-react';
import { fileExplorerState } from '../state/fileExplorerState';
import { deleteFiles$, clearSelection$ } from '../commands/fileCommands';
export default function Toolbar() {
    const selectedFileIds = useGet(fileExplorerState.selectedFileIds$);
    const deleteFiles = useSet(deleteFiles$);
    // const moveFiles = useSet(moveFiles$) // Unused for now
    const clearSelection = useSet(clearSelection$);
    const hasSelection = (selectedFileIds as string[]).length > 0;
    const handleDelete = async () => {
        if ((selectedFileIds as string[]).length > 0 && confirm('Are you sure you want to delete the selected items?')) {
            try {
                await deleteFiles(selectedFileIds as string[]);
            }
            catch (error) {
                console.error('Failed to delete files:', error);
            }
        }
    };
    const handleMove = () => {
        // In a real app, this would open a folder picker modal
        console.log('Move files:', selectedFileIds);
    };
    const handleCopy = () => {
        // In a real app, this would copy files to clipboard
        console.log('Copy files:', selectedFileIds);
    };
    if (!hasSelection) {
        return null;
    }
    return (<div className="flex items-center gap-4 px-6 py-3 bg-[#E8F2FC] border-b border-[#4A90E2]" data-id="mbq46s">
      <div className="flex items-center gap-2" data-id="ogx54p">
        <Icon icon="lucide:check-circle" className="w-5 h-5 text-[#4A90E2]" data-id="ggui2l"/>
        <span className="text-sm font-medium text-[#1A2B3D]" data-id="l9r3ju">
          {(selectedFileIds as string[]).length} item{(selectedFileIds as string[]).length === 1 ? '' : 's'} selected
        </span>
      </div>

      <div className="flex items-center gap-2 ml-auto" data-id="wu5nr3">
        <button onClick={handleMove} className="flex items-center gap-2 px-3 py-1.5 text-sm text-[#4A90E2] hover:bg-white/50 rounded" data-testid="toolbar-move-button" data-id="g381sp">
          <Icon icon="lucide:move" className="w-4 h-4" data-id="3ael8b"/>
          Move
        </button>

        <button onClick={handleCopy} className="flex items-center gap-2 px-3 py-1.5 text-sm text-[#4A90E2] hover:bg-white/50 rounded" data-testid="toolbar-copy-button" data-id="uw2s1p">
          <Icon icon="lucide:copy" className="w-4 h-4" data-id="ophqgc"/>
          Copy
        </button>

        <button onClick={handleDelete} className="flex items-center gap-2 px-3 py-1.5 text-sm text-[#E53935] hover:bg-white/50 rounded" data-testid="toolbar-delete-button" data-id="5u8huv">
          <Icon icon="lucide:trash-2" className="w-4 h-4" data-id="acq8iu"/>
          Delete
        </button>

        <div className="w-px h-6 bg-[#D1DAE5] mx-2" data-id="p6xjkt"/>

        <button onClick={() => clearSelection()} className="flex items-center gap-2 px-3 py-1.5 text-sm text-[#5A6C7D] hover:bg-white/50 rounded" data-testid="toolbar-clear-selection" data-id="o1ypna">
          <Icon icon="lucide:x" className="w-4 h-4" data-id="0rluoh"/>
          Clear selection
        </button>
      </div>
    </div>);
}
